import { sortCOPSModelToParam, sortParamToCOPSModel } from 'utils/helpers';
import {
    defaultView,
    ticketWorklistId,
    viewTypes,
} from '../utils/app-configs';

// 3 use cases:
// 1. View exists but sort/filters are different => use view but use url params for sort/filters
// 2. View exists and sort/filters are the same => Use this view
// 3. view does not exists => default to none with filters and sort of none view ord url params.
const decideInitialView = (viewsArray, match, isTickets = false, defaultSort = '') => {
    if (viewsArray.length) {
        if (isTickets && match.params.objectId) {
            const defaultViewObject = viewsArray?.find(v => v.isDefault);
            const ticketSystemView = viewsArray?.find(v => v.templateType === viewTypes.system);

            if (defaultViewObject) {
                return defaultViewObject;
            }
            if (ticketSystemView) {
                return ticketSystemView;
            }
            return viewsArray?.find(v => v.isNone);
        }
        if ((match.params.worklistId || isTickets) && match.params.view) {
            const viewFromUrl = viewsArray?.find(v => v.id === match.params.view);
            // View exists in array, use params from url or view
            if (viewFromUrl) {
                const activeSort = sortCOPSModelToParam(viewFromUrl.sorting);
                const sortParam = match.params.sort === activeSort ?
                    activeSort :
                    match.params.sort || activeSort;
                const filterData = match.params.filters === viewFromUrl.filterData ?
                    viewFromUrl.filterData :
                    match.params.filters || viewFromUrl.filterData;
                return {
                    ...viewFromUrl,
                    sorting: sortParamToCOPSModel(
                        sortParam ||
                        defaultSort,
                    ),
                    filterData: filterData || '',
                };
            }
            // View does not exist in viewarray of user =>
            // default to none but with url params if exist
            const noneView = viewsArray?.find(v => v.isNone);
            return {
                ...noneView,
                sorting: sortParamToCOPSModel(
                    match.params.sort ||
                    defaultSort,
                ),
                filterData: match.params.filters || '',
            };
        }
        return viewsArray?.find(v => v.isDefault) || viewsArray?.find(v => v.isNone);
    }
    const noneId = isTickets ? ticketWorklistId : match.params.worklistId;
    return {
        id: `${noneId}_none`,
        ...defaultView,
        sorting: sortParamToCOPSModel(defaultSort),
    };
};

export default decideInitialView;
